module.exports = __webpack_public_path__ + "img/solution5.96405300.png";